// @ts-check
import { initFinstralSlider } from "../../../js/utils/finstral-slider.js";

class Slider extends HTMLElement {
	/** @type {(() => void) | null} */
	#teardown = null;

	connectedCallback() {
		this.#teardown = initFinstralSlider(this, {
			trackSelector: ".js-Slider-track",
			slideSelector: ".js-Slider-slide",
			buttonPreviousSelector: ".js-Slider-navigationButton--previous",
			buttonNextSelector: ".js-Slider-navigationButton--next",
			indicatorDotSelector: ".js-Slider-indicatorDot",
		});
	}

	disconnectedCallback() {
		this.#teardown?.();
		this.#teardown = null;
	}
}

if (!customElements.get("finstral-slider")) {
	customElements.define("finstral-slider", Slider);
}
